import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { importData, toggleSort } from '../actions';

import Table from './Table';
import TableLoading from './TableLoading';

class DataTable extends Component {
    static propTypes = {
        stateKey: PropTypes.string.isRequired,
        config: PropTypes.object.isRequired,
        sort: PropTypes.func,
        update: PropTypes.func,
        tableProps: PropTypes.object,
        header: PropTypes.array,
        rows: PropTypes.array,
        selectedRows: PropTypes.array,
        loading: PropTypes.bool,
        errorMessage: PropTypes.string,
        colSpanGetter: PropTypes.func,
        onMount: PropTypes.func,
        onDidMount: PropTypes.func
    };

    static defaultProps = {
        onDidMount: () => null
    };

    constructor(props) {
        super(props);

        if (props.onMount) {
            props.onMount(props);
        }
    }

    componentDidMount() {
        this.props.onDidMount(this.props);
    }

    render() {
        return (
            <TableLoading loading={this.props.loading}>
                <Table
                    cssClass={this.props.config.tableClass}
                    columns={this.props.config.columns}
                    primaryColumn={this.props.config.primaryColumn}
                    header={this.props.header}
                    rows={this.props.rows}
                    selectedRows={this.props.selectedRows}
                    onSort={this.props.sort}
                    colSpanGetter={this.props.colSpanGetter}
                    {...this.props.tableProps}
                >
                    {this.props.errorMessage}
                </Table>
            </TableLoading>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { dataTable } = get(state, ownProps.stateKey);

    return {
        header: dataTable.header,
        rows: dataTable.rows,
        loading: dataTable.loading,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    const update = data => dispatch(importData(ownProps.stateKey, data));
    const sort = columnName => dispatch(toggleSort(ownProps.stateKey, columnName));

    return { sort, update };
}

const DataTableDefault = connect(mapStateToProps, mapDispatchToProps)(DataTable);

export { DataTable as default, DataTableDefault };



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/components/index.js